import { useState } from 'react';

import DataLengthCheckModal from '../components/DataLengthCheckModal';

const operators = [
    { id: 1, name: 'Greater_than', value: '>' },
    { id: 2, name: 'Less_than', value: '<' },
    { id: 3, name: 'Greater_than_equal_to', value: '>=' },
    { id: 4, name: 'Less_than_euqal_to', value: '<=' },
    { id: 5, name: 'Equal_to', value: '=' },
    { id: 6, name: 'between', value: 'between' },
];

const DataLengthCheckModalContainer = ({
    isDataLengthCheckModalvisible, setIsDataLengthCheckModalvisible, columnName,
    columnId, ruleId, onAddDataLengthCheckDetails, onCancelDataLengthCheckDetails,
}) => {
    const [operator, setOperator] = useState('');
    const [value1, setValue1] = useState('');
    const [value2, setValue2] = useState('');

    const isBetweenRangeValid = operator === 'between' && (value1 === '' || value2 === '');
    const isValueValid = operator !== 'between' && value1 === '';
    const disableSaveBtn = operator === '' || isBetweenRangeValid || isValueValid;

    const onSaveDataLengthCheckDetails = () => {
        const input = {
            columnId,
            columnName,
            ruleId,
            operator,
            value1,
            value2,
        };
        onAddDataLengthCheckDetails(input);
    };

    const onCancel = () => {
        const input = {
            columnId,
            columnName,
            ruleId,
            operator,
            value1,
            value2,
        };
        onCancelDataLengthCheckDetails(input);
        setIsDataLengthCheckModalvisible(false);
    };

    return (
        <DataLengthCheckModal
            isDataLengthCheckModalvisible={isDataLengthCheckModalvisible}
            setIsDataLengthCheckModalvisible={setIsDataLengthCheckModalvisible}
            onSaveDataLengthCheckDetails={onSaveDataLengthCheckDetails}
            columnName={columnName}
            operators={operators}
            operator={operator}
            setOperator={setOperator}
            value1={value1}
            setValue1={setValue1}
            value2={value2}
            setValue2={setValue2}
            disableSaveBtn={disableSaveBtn}
            onCancel={onCancel}
        />
    );
};

export default DataLengthCheckModalContainer;
